<template>
    <div class="class-and-stu">
        <div>
            <Title :title="'学校管理'"></Title>
            <div class="manage-area-main" style="margin-top: 20px">
                <div>
                    <Button type="primary" @click="addSchoolBtn">添加学校</Button>
                </div>
                <div style="padding: 20px;background: #ffffff">
                    <Table :columns="columns" :data="school_data.body"></Table>
                    <div  class="page-box" v-if="school_data.page">
                        <Page show-sizer
                              show-total
                              :page-size="school_data.page.page_size"
                              :current="school_data.page.current"
                              :total="school_data.page.count"
                              @on-change="currentPage"
                              @on-page-size-change="pageSizeChange"
                        />
                    </div>
                </div>
            </div>
            <Modal
                    v-model="addSchoolModal"
                    title="添加学校"
                    @on-ok="add"
                    @on-cancel="cancel">
                <div class="add-class-form">
                    <Form :model="addSchoolForm" label-position="right" :label-width="100">
                        <FormItem label="学校名称">
                            <Input v-model="addSchoolForm.name" style="width: 70%" placeholder="请输入学校名称"></Input>
                        </FormItem>
                        <FormItem label="联系方式">
                            <Input v-model="addSchoolForm.telephone" style="width: 70%" placeholder="请输入联系方式"></Input>
                        </FormItem>
                        <FormItem label="学校地址">
                            <Input v-model="addSchoolForm.address" style="width: 70%" placeholder="请输入学校地址"></Input>
                        </FormItem>
                        <FormItem label="学校域名后缀">
                            <Input v-model="addSchoolForm.domain" style="width: 70%" placeholder="qhdx"></Input>
                        </FormItem>
                        <FormItem label="备注">
                            <Input v-model="addSchoolForm.remark" type="textarea" style="width: 70%" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入备注"></Input>
                        </FormItem>
                    </Form>
                </div>
            </Modal>
            <Modal
                    v-model="editSchoolModal"
                    title="编辑学校"
                    @on-ok="editOk"
                    @on-cancel="cancel">
                <div class="add-class-form">
                    <Form :model="editSchoolForm" label-position="right" :label-width="100">
                        <FormItem label="学校名称">
                            <Input v-model="editSchoolForm.name" style="width: 70%" placeholder="请输入学校名称"></Input>
                        </FormItem>
                        <FormItem label="联系方式">
                            <Input v-model="editSchoolForm.telephone" style="width: 70%" placeholder="请输入联系方式"></Input>
                        </FormItem>
                        <FormItem label="学校地址">
                            <Input v-model="editSchoolForm.address" style="width: 70%" placeholder="请输入学校地址"></Input>
                        </FormItem>
                        <FormItem label="学校域名后缀">
                            <Input v-model="editSchoolForm.domain" style="width: 70%" placeholder="qhdx"></Input>
                        </FormItem>
                        <FormItem label="备注">
                            <Input v-model="editSchoolForm.remark" style="width: 70%" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入备注"></Input>
                        </FormItem>
                    </Form>
                </div>
            </Modal>
        </div>
    </div>
</template>

<script>
    import Title from '../../../ability/components/title'
    import {mapActions, mapState} from 'vuex'
    import cookies from "vue-cookies";
    import moment from "moment";
    export default {
        name: "school",
        components: {
            Title,
        },
        data() {
            return {
                addSchoolModal:false,
                editSchoolModal:false,
                edit_school_id:null,
                page_num:1,
                page_size:20,
                addSchoolForm:{
                    name:'',
                    telephone:'',
                    address:'',
                    domain:'',
                    remark:'',
                },
                editSchoolForm:{
                    name:'',
                    telephone:'',
                    address:'',
                    domain:'',
                    remark:'',
                },
                columns: [
                    {
                        title:'ID',
                        key:'schoolId',
                        width:65,
                        sortable: true
                    },
                    {
                        title:'学校名称',
                        key:'name'
                    },
                    {
                        title:'域名后缀',
                        key:'domain',
                        width:120,
                    },
                    {
                        title:'创建时间',
                        key:'ctime',
                        sortable: true,
                        render: (h, params) => {
                            return h('div', [
                                h('span', {

                                }, moment(params.row.ctime).format('YYYY-MM-DD HH:mm:ss ')),
                            ]);
                        }
                    },
                    {
                        title:'更新时间',
                        key:'mtime',
                        sortable: true,
                        render: (h, params) => {
                            return h('div', [
                                h('span', {

                                }, moment(params.row.mtime).format('YYYY-MM-DD HH:mm:ss')),
                            ]);
                        }
                    },
                    {
                        title:'备注',
                        key:'remark',
                        tooltip:true,
                    },
                    {
                        title: '操作',
                        key: 'action',
                        render: (h, params) => {
                            return h('div', [
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.showStuList(params.row)
                                        }
                                    }
                                }, '教管人员'),
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.editRow(params.row)
                                        }
                                    }
                                }, '编辑'),
                                h('a', {
                                    style: {
                                        marginRight: '5px',
                                        color:'#029ff6'
                                    },
                                    on: {
                                        click: () => {
                                            this.delCurSchool(params.row)
                                        }
                                    }
                                }, '删除'),
                            ]);
                        }
                    },
                ],
            }
        },
        computed: {
            ...mapState({
                school_data: state => state.schoolManage.school_data,
            }),
        },
        methods: {
            ...mapActions({
                getSchool: 'schoolManage/getSchool',
                addSchool:'schoolManage/addSchool',
                delSchool:'schoolManage/delSchool',
                editSchool:'schoolManage/editSchool',
            }),
            addSchoolBtn(){
                this.addSchoolModal = true
            },
            editRow(row){
                this.editSchoolModal = true
                this.edit_school_id = row.schoolId
                this.editSchoolForm = {
                    name:row.name,
                    telephone:row.telephone,
                    address:row.address,
                    domain:row.domain,
                    remark:row.remark,
                }
            },
            editOk(){
                let _this = this
                this.editSchool({
                    data:_this.editSchoolForm,
                    school_id:_this.edit_school_id,
                    callback:res =>{
                        _this.$Message.success(res.message)
                        _this.initSchool()
                    },
                    err:msg =>{
                        _this.$Message.error(msg)
                    }
                })
            },
            showStuList(row){
                this.$router.push({
                    name: 'adminManage',
                    params: {id: row.schoolId,name:row.name,domain:row.domain},
                })
            },
            currentPage(num){
                this.page_num = num
                this.initSchool()
            },
            pageSizeChange(size){
                this.page_size = size
                this.initSchool()
            },
            delCurSchool(row){
                let _this = this
                this.$Modal.confirm({
                    title: '删除学校',
                    content: `确认要删除<b style="color: #2b85e4">${row.name}</b>吗！`,
                    cancelText: '取消',
                    onOk:function(){
                        _this.delSchool({
                            school_id:row.schoolId,
                            callback:res =>{
                                _this.$Message.success(res.message)
                                _this.initSchool()
                            },
                            err:msg =>{
                                _this.$Message.error(msg)
                            }
                        })
                    }
                });
            },
            add(){
                let _this = this
                this.addSchool({
                   data:_this.addSchoolForm,
                   callback:res =>{
                       _this.$Message.success('创建学校成功！')
                       _this.initSchool()
                       _this.addSchoolForm = {
                           name:'',
                           telephone:'',
                           address:'',
                           domain:'',
                           remark:'',
                       }
                   },
                    err:msg =>{
                        _this.$Message.error(msg)
                    }
                })
            },
            cancel(){

            },
            initSchool(){
                let _this = this
                this.getSchool({
                    sort:'-name|ctime',
                    page_num:_this.page_num,
                    page_size:_this.page_size
                })
            }

        },
        mounted () {
            this.initSchool()
        },
    }
</script>
<style lang="less">
    .add-class-form{
        .ivu-form-item {
            margin-bottom: 20px;
        }
    }
</style>
<style scoped lang="less">
    @import "../../style/index";
    .add-class-form{

    }
</style>
